import { autoinject } from "aurelia-framework";
import { BaseEditor } from "./base-range-rule-editor";
import { Api } from "../../../services/api";
import { MdToastService } from "aurelia-materialize-bridge";
import { I18N } from "aurelia-i18n";

@autoinject
export class PropertyEditor extends BaseEditor {

	constructor(api: Api, toastService: MdToastService, i18n: I18N) {
		super(api, toastService, i18n);
	}

	activate(model: any) {
		super.activate(model);
	}

	async applyChanges() {
		const data = this.property.value;
		const result = await this.addOrUpdateProperty(data);
	}

	async delete() {
		const result = await super.deleteProperty(this.property);
	}
}
